// extracted by mini-css-extract-plugin
export default {"basketButton":"styles_basketButton__4mIFO","basketBadge":"styles_basketBadge__txVtC"};